import { Component, OnInit } from "@angular/core";
import { BreadcrumbService, IBreadcrumb } from "@services/breadcrumb.service";
import { NavigationService } from "@services/navigation.service";
import "./route-breadcrumbs.component.scss";

@Component({
    selector: "route-breadcrumbs",
    template: require("./route-breadcrumbs.component.html")
})
export class RouteBreadcrumbsComponent implements OnInit {

    breadcrumbs: IBreadcrumb[] = [];

    showBackButton = false;
    backBreadcrumb: IBreadcrumb;

    constructor(
        private readonly breadcrumbService: BreadcrumbService,
        private readonly navigationService: NavigationService
    ) {
        this.breadcrumbService.registerStateCallback(() => this.updateBreadcrumbs());
    }

    ngOnInit() {
        this.updateBreadcrumbs();
    }

    breadcrumbClicked(breadcrumb: IBreadcrumb, $event: MouseEvent) {
        this.navigationService.go(breadcrumb.state.name, null, false);

        $event.preventDefault();
    }

    // ---

    private updateBreadcrumbs() {
        this.showBackButton = false;
        this.breadcrumbs = this.breadcrumbService.getBreadcrumbs();

        if (this.breadcrumbs.length <= 1) {
            return;
        }

        // If our parent state ISNT abstract, then show "Back to X"
        var currentBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 1];
        var parentBreadcrumb = this.breadcrumbs[this.breadcrumbs.length - 2];

        if (currentBreadcrumb.state && !parentBreadcrumb.state.abstract && !parentBreadcrumb.state.data.preventBreadcrumbBack) {
            this.showBackButton = true;
            this.backBreadcrumb = parentBreadcrumb;
        }
    }
}
